import React, { ChangeEvent, LegacyRef, useEffect, useRef } from "react";
import {
  Input,
  InputGroup,
  InputLeftElement,
  useBreakpointValue,
} from "@chakra-ui/react";
import {
  Color,
  Icon,
  IconType,
} from "theme/old-design-system/styled-components";
import useConversationsStore from "hooks/use-conversations-store";
import useMerchantStore from "hooks/use-merchant-store";
import useAgentsStore from "hooks/use-agents-store";
import useAnalytics from "hooks/use-analytics";
import useCustomChakraTheme from "hooks/use-custom-chakra-theme";

interface ContactsSearchProps {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  value: string;
  isDisabled: boolean;
}

const ContactsSearch = ({
  onChange,
  value,
  isDisabled,
}: ContactsSearchProps) => {
  const { activeConversationId } = useConversationsStore();
  const { colorScheme } = useCustomChakraTheme();
  const { merchant } = useMerchantStore();
  const { currentAgent } = useAgentsStore();
  const { trackAnalytics } = useAnalytics();
  const isBaseSize = useBreakpointValue(
    { base: true, md: false },
    { ssr: false }
  );
  const inputRef = useRef<HTMLInputElement>();

  useEffect(() => {
    if (!isDisabled && !isBaseSize) {
      inputRef?.current?.focus();
    }
  }, [isDisabled]);

  return (
    <InputGroup flex="0 0 1px">
      <InputLeftElement pointerEvents="none">
        <Icon
          type={IconType.SEARCH}
          pathFill={Color.DARK_GREY}
          height={17}
          width={17}
        />
      </InputLeftElement>
      <Input
        colorScheme={colorScheme}
        ref={inputRef as LegacyRef<HTMLInputElement> | undefined}
        isDisabled={isDisabled}
        placeholder="John Doe"
        onChange={onChange}
        onClick={() => {
          trackAnalytics("customers_search_bar_focused", {
            merchant_id: merchant.id,
            agent_id: currentAgent?.id,
            conversation_id: activeConversationId || null,
            distinct_id: `merchant:${merchant.id}`,
            motive: "inbox",
          });
        }}
        value={value}
        borderRadius="63px"
      />
    </InputGroup>
  );
};

export default ContactsSearch;
